import { z } from 'zod';

import { PeoStaffRole, UserStatus } from 'src/api';

import { accessRestrictionModeFormValidationSchema } from '../../AccessRestrictionModeFormPart';
import { DetailsFormFields } from '../constants';

const detailsFormMetaInfoValidationSchema = z.object({
  [DetailsFormFields.userStatus]: z.enum(UserStatus),
  [DetailsFormFields.businessRole]: z.enum(PeoStaffRole),
});

export const getDetailsFormResolvedValidationSchema = (canEditStatusAndRole: boolean) => {
  return canEditStatusAndRole
    ? accessRestrictionModeFormValidationSchema.and(detailsFormMetaInfoValidationSchema)
    : accessRestrictionModeFormValidationSchema;
};
